<template>
    <div>
        <div id="add-chief-complaints" tabindex="-1" data-focus-on="input:first" class="modal fade" role="dialog"
            data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog grt-md wd-770">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" id="closebutton">&times;</button>
                    </div>
                    <div class="modal-body px-60">
                        <h4 class="modal-title">Chief Complaints</h4>
                        <div class="chief-complaints-wrapper" ref="dropdownWrapper">
                            <!-- Input and Chips -->
                            <div class="input-wrapper">
                                <div class="chips">
                                    <span v-for="(chip, index) in chips" :key="index" class="chip">
                                        {{ chip }}
                                        <span @click="removeChip(index)">✕</span>
                                    </span>

                                    <!-- Search input appears inline with chips   @keypress="allowAlphabetsAndSpace"-->
                                    <input ref="searchInput" type="text" v-model="displaySearch" maxlength="100"
                                        @keydown.enter.prevent="addChipFromInput"
                                        :placeholder="chips.length === 0 ? 'Chief complaints' : 'Add more'"
                                        class="chip-input" @input="onInputChange" />
                                </div>
                            </div>

                            <!-- Dropdown with checkboxes -->
                            <div v-if="dropdownVisible" class="dropdown">
                                <!-- Radio: Check/Uncheck All -->
                                <div class="radio-options">
                                    <label class="radio-label">
                                        <input type="radio" name="checkAll" @change="selectAll" />
                                        Check all
                                    </label>
                                    <label class="radio-label">
                                        <input type="radio" name="checkAll" @change="unselectAll" />
                                        Uncheck all
                                    </label>
                                </div>

                                <div v-for="(item, index) in filteredList" :key="index">
                                    <label class="dropdown-option-label" :class="{ disabled: chips.includes(item) }">
                                        <input type="checkbox" :value="item" :checked="chips.includes(item)"
                                            @change="toggleChip(item)" />
                                        <span v-html="highlightMatch(item)"></span>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="height-dft" v-bind:class="{ 'error-msg-hold': Validatenote }">
                            <span class="error">Please select at least one item.</span>
                        </div>
                    </div>
                    <div class="modal-footer px-60">
                        <button @click="clearAllChips" type="button" class="secondary-btn">Clear All</button>
                        <span>{{search}}</span>
                        <button type="button" class="primary-btn ripple"  @click="save">Save</button>
                    </div>
                </div>
            </div>
        </div>
         <!-- Start Success process message popup -->
    <transition name="fade">
      <Messages
        :datamessage="sucessmsgtext"
        :iserror="iserrormsg"
        @closemsg="closeMessage"
        :isVisible="isdisplaymsg"
      ></Messages>
    </transition>
    </div>
   
</template>
<script>
import Messages from "@/components/MessagePopup/Messages.vue";
export default {
    name:"ChiefComplaintsPopup",
    props: ["ChiefComplaintsList", "SelectedChiefComplaintsList"],
    components: {
        Messages,
    },
    data() {
        return {
            search: '',
            displaySearch: "",
            chips: [],
            dropdownVisible: false,
            Validatenote:false,
            isdisplaymsg: false,
            iserrormsg: false,
            sucessmsgtext: "",
            IsEmpptySave: false,
        };
    },
    created: function() {
        
    },
    computed: {
        filteredList() {
            const keyword = (this.displaySearch || this.search || "").toLowerCase();
            return this.ChiefComplaintsList.filter(
                item => item.toLowerCase().includes(keyword)
            );
        }
    },
    methods: {
        closeMessage() {
            this.isdisplaymsg = false;
            this.iserrormsg = false;
        },
        updateChips() {
            if (Array.isArray(this.SelectedChiefComplaintsList)) {
            this.chips = [...new Set(this.SelectedChiefComplaintsList)];
            }
        },
        allowAlphabetsAndSpace(event) {
            const char = String.fromCharCode(event.keyCode || event.which);
            if (!/^[a-zA-Z ]$/.test(char)) {
                event.preventDefault();
            }
        },
        highlightMatch(item) {
            if (!this.search) return item;

            // Escape special regex characters in search
            const escapedSearch = this.search.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

            const regex = new RegExp(`(${escapedSearch})`, 'gi');
            
            // Replace matched part with span
            return item.replace(regex, '<span class="highlight">$1</span>');
        },
        onInputChange() {
            this.search = this.displaySearch; 
            this.dropdownVisible = this.search.trim().length > 0;
        },
        clearAllChips() {
            this.chips = [];
            this.IsEmpptySave= true;
        },
        handleClickOutside(event) {
            if (
                this.$refs.dropdownWrapper &&
                !this.$refs.dropdownWrapper.contains(event.target)
            ) {
                this.dropdownVisible = false;
                this.search = '';
            }
        },
        addChipFromInput() {
            debugger;
            const trimmed = this.search.trim().toLowerCase();
            if (trimmed && !this.chips.includes(trimmed)) {
                this.chips.push(trimmed);
            }
            this.displaySearch = "";
            if (this.$refs.searchInput) {
                this.$refs.searchInput.focus();
            }
        },  
        
        toggleChip(item) {
            if (this.chips.includes(item)) {
                this.chips = this.chips.filter(chip => chip !== item);
            } else {
                const currentLength = this.chips.join(', ').length;
                const additionalLength = item.length + (this.chips.length > 0 ? 2 : 0);

                if (currentLength + additionalLength <= 100) {
                    this.chips.push(item);
                    this.displaySearch = "";
                } else {
                    this.isdisplaymsg = true;
                    this.iserrormsg = true;
                    this.sucessmsgtext = "Maximum 100 characters allowed for Chief Complaints.";
                    setTimeout(this.closeMessage, this.$store.state.helper.msgDisplayTime);
                    this.displaySearch = "";
                }
            }
        },


        removeChip(index) {
            this.chips.splice(index, 1);
        },
        selectAll() {
            const toAdd = this.filteredList.filter(item => !this.chips.includes(item));
            const currentLength = this.chips.join(', ').length;

            let addedLength = 0;
            const allowedChips = [];

            for (const item of toAdd) {
                const itemLength = item.length + (this.chips.length + allowedChips.length > 0 ? 2 : 0); 
                if (currentLength + addedLength + itemLength <= 100) {
                    allowedChips.push(item);
                    addedLength += itemLength;
                } else {
                    this.isdisplaymsg = true;
                    this.iserrormsg = true;
                    this.sucessmsgtext = "Maximum 100 characters allowed for Chief Complaints.";
                    setTimeout(
                        function () {
                            this.closeMessage();
                        }.bind(this),
                        this.$store.state.helper.msgDisplayTime
                    );
                    break; 
                }
            }

            this.chips = [...this.chips, ...allowedChips];
        },

        unselectAll() {
            this.chips = this.chips.filter(chip => !this.filteredList.includes(chip));
        },
        save() {
            // if (this.chips.length <=0) {
            //     this.Validatenote = true;
            //     return;
            // }
            this.Validatenote = false;
            this.$emit('save', [...this.chips]);
        }

    },
    mounted() {
        document.addEventListener('click', this.handleClickOutside);
        const modalElement = document.getElementById('add-chief-complaints');
        if (modalElement) {
            $(modalElement).on('shown.bs.modal', this.updateChips);
        }
    },
    beforeDestroy() {
        const modalElement = document.getElementById('add-chief-complaints');
        if (modalElement) {
            $(modalElement).off('shown.bs.modal', this.updateChips);
        }
    },
    beforeUnmount() {
        document.removeEventListener('click', this.handleClickOutside);
    },
    updated: function() {

    },
    watch: {
        search() {
            if (this.chips.length>0) {
                this.Validatenote = false;
            }
        }
    }
}
</script>
<style scoped>
    .disabled {
        opacity: 0.6;
    }
    .chief-complaints-wrapper {
        width: 100%;
        position: relative;
    }

    .input-wrapper {
        border: 1px solid #ccc;
        padding: 6px;
        border-radius: 5px;
        min-height: 42px;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        width: 100%;
    }

    .chips {
        display: flex;
        flex-wrap: wrap;
        gap: 5px;
        align-items: center;
        flex-grow: 1;
    }

    .chip {
        background-color: #0056e0;
        padding: 6px 10px;
        border-radius: 20px;
        display: flex;
        align-items: center;
        font-size: 14px;
        color: #FFF;
    }

    .chip span {
        margin-left: 6px;
        cursor: pointer;
    }

    .chip-input {
        flex: 1;
        border: none !important;
        outline: none;
        font-size: 14px;
        min-width: 100px;
        padding: 6px 4px;
    }

    input[type="text"] {
        width: 100%;
        border: none;
        outline: none;
    }

    .dropdown {
        border: 1px solid #ccc;
        padding: 10px;
        max-height: 200px;
        overflow-y: auto;
        background: white;
        position: absolute;
        z-index: 1000;
        width: 100%;
    }

    .radio-options {
        display: inline-flex;
        flex-direction: row;
        align-items: center;
        gap: 12px; /* Keep them close together */
        margin-bottom: 10px;
        flex-wrap: nowrap;
    }

    .radio-label {
        display: flex;
        align-items: center;
        font-size: 14px;
        gap: 4px;
        margin: 0;
        white-space: nowrap;
        color: #0056e1;
    }

    .dropdown-option-label {
        display: flex;
        align-items: center;
        gap: 6px;
    }

    ::v-deep .highlight {
        background-color: #80EDAD;
        font-weight: bold;
        border-radius: 3px;
        padding: 0 2px;
    }
    #add-chief-complaints .modal-dialog .modal-content {
        padding-top: 0;
    }
    #add-chief-complaints .modal-header .close {
       padding: 0;
       margin: 0;
    }
</style>